import { ACTION_TYPES } from 'constants'

const initialState = {
  contactDetails: false,
}

const ContactDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.CONTACT_DETAILS: {
      return {
        ...state,
        contactDetails: action.payload,
      }
    }
    default:
      return state
  }
}

export default ContactDetailsReducer
